module.exports = __webpack_public_path__ + "img/65400.c7153249.jpg";